// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b3-3";
export var contentContainer = "_b3-0";
export var editorContainer = "_b3-1";
export var quillInputForm = "_b3-2";
export var zoneDivider = "_b3-4";